// import { height } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";

import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../redux/store";
import AuthModal from "../../components/Modal";
import { Alert } from "react-bootstrap";
import { logoutUser } from "../../redux/actions";
import api from "../../utils/ApiMethod";
import { ADMIN_LOGIN_BASE_URL } from "../../apiservices/apiService";

interface Child {
  _id: string;
  url?: string;
  title?: string;
  sportDetails: string;
  image: string;
  isDeleted: boolean;
  address?: string;
  pin?: string;
  bgColor?: string;
  text?: string;
  content?: string;
  introduction?: string;
  researchBy?: string;
  awards?: string;
  yearOfResearch?: string;
}

interface link {
  _id: string;
  title: string;
  url: string;
  image: string;
  pin: string;
  isDeleted: boolean;
}

interface address {
  _id: string;
  title: string;
  address: string;
  pin: string;
  isDeleted: boolean;
}

interface Parent {
  itemId?: string; // Replace 'boolean' with the appropriate type if needed
  _id?: string;
  text?: string;
  content?: string;
  bannerUrl?: string;
  mobileBannerUrl?: string;
  name?: string;
  numberOfVisitors: string;
  data: [] | undefined;
  aboutus?: string; // An array of OrgtnalSruItem objects
  facultyAndStaff?: string; // An array of OrgtnalSruItem objects
  researchAndPublications?: string; // An array of OrgtnalSruItem objects
  academics?: string; // An array of OrgtnalSruItem objects
  inPatientService?: string; // An array of OrgtnalSruItem objects
  outPatientService?: string; // An array of OrgtnalSruItem objects
  priceList?: string; // An array of OrgtnalSruItem objects
  MisionAndVision?: string; // An array of OrgtnalSruItem objects
  links?: string; // An array of OrgtnalSruItem objects
  gallery?: string; // An array of OrgtnalSruItem objects
  innerData?: Child[];
  // OrgtnalSruItem:array;
  isDeleted: boolean;
}

interface id {
  id: string;
  link?: string;
  name?: string;
}

interface Props {
  itemId: string; // Replace 'boolean' with the appropriate type if needed
  parentId?: string;
  innerdata: Child[];
  innerData?: Child[]; // Specify the correct type for innerData

  name?: string;
}

interface parentId {
  itemId?: string; // Replace 'boolean' with the appropriate type if needed
  id?: string;
  _id?: string | undefined;
  text?: string;
  parentId?: string | undefined;
  // data?: typeof parent[];
  data?: Parent[]; // Specify the correct prop type

  link?: string; // An array of OrgtnalSruItem objects
  address?: string;
  joinus?: string;
  inportantLink?: string;
  name?: string;
  innerData?: Child[];
}

const footerItems = [
  { name: "About Department" },
  { name: "Faculty & Staff" },
  { name: "Research & Publications" },
  { name: "Academics" },
  { name: "In Patient Services" },
  { name: "Out Patient Services" },
  { name: "Price List" },
  { name: "Links" },
  { name: "Gallery" },
  { name: "Mission & Vision" },
  // { name: "numberOfVisitors" }
];

let parentTabId = "";

const DeleteDepartment: React.FC<parentId> = ({ data }) => {
  const [validated, setValidated] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const [isEditItem, setIsEditItem] = useState<string>("");

  // const [data, setData] = useState<Parent[]>([]);

  const { user, userLoggedIn, loading, error, userId } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
      userId: state.Auth._id,
    })
  );
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  const deleteItem = async (itemId: string) => {
    try {
      // const response = await fetch(
      //   // `http://165.22.219.69:5002/api/delete/footerpage/${itemId}`,
      //   `http://165.22.219.69:5002/api/delete/footerpage/${itemId}/${profileId}/${Key_Key}`,
      //   {
      //     method: "PATCH",
      //     credentials: "include",
      //   }
      // );
      const response = await api.updatePatchDataDelete(
        `/api/delete/department/${itemId}/${profileId}/${Key_Key}`,
        ""
      );

      if (response.status === 440) {
        alert("Session Expired");
        dispatch(logoutUser());
        window.location.href = ADMIN_LOGIN_BASE_URL;
      }
      if (
        response.status == 200 ||
        response.status == 201 ||
        response.status == 204
      ) {
        alert("Deleted");
        window.location.reload();
      }
      // Assuming you want to parse the JSON response
      const data = await response.json();
      const userConfirmed = window.confirm("Deleted");

      if (userConfirmed) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error during edit the banner:", error);
    }
  };

  const editItem = async (id: string) => {
    let newEditItem = data?.find((elem) => {
      return elem._id === id;
    });
    setIsEditItem(id);
  };

  const activeDepartment = async (id: string) => {
    let newEditItem = data?.find((elem) => {
      return elem._id === id;
    });
    localStorage.setItem("parentId", String(id));
    // console.log('parentId', parentId)
  };

  return (
    <>
      <>
        <Row>
          {isEditItem ? (
            <Col lg={12}>
              <UpdateDepartment
                itemId={isEditItem}
                // parentId={id}
                // innerData={data ||[]}
                // name={name}
              />
            </Col>
          ) : (
            <Card>
              <Card.Body>
                <h4>Delete and Update Departments</h4>

                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Sr. N</th>
                      <th>Title</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(data || [])?.map((item: parentId, i) => (
                      <tr key={item?._id}>
                        <td>{i + 1}</td> {/* You can use i+1 as the index */}
                        <td>{item?.text}</td>
                        <td>
                          {/* Delete button */}
                          {/* <div className="row">
                      <button
                        onClick={() => deleteItem(item?._id ?? "")}
                        className="btn btn-danger"
                      >
                        Delete
                      </button>


                      </div> */}
                          <Row className="gap-2">
                            <Col lg={3}>
                              <button
                                onClick={() => deleteItem(item?._id ?? "")}
                                className="btn btn-danger"
                              >
                                Delete
                              </button>
                            </Col>

                            <Col lg={3}>
                              <button
                                onClick={() => editItem(item?._id ?? "")}
                                className="btn btn-primary"
                              >
                                Update
                              </button>
                            </Col>

                            <Col lg={3}>
                              <button
                                onClick={() =>
                                  activeDepartment(item?._id ?? "")
                                }
                                className="btn btn-success"
                              >
                                Open
                              </button>
                            </Col>
                          </Row>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          )}
        </Row>
      </>
    </>
  );
};

const UpdateDepartment: React.FC<parentId> = ({ itemId }) => {
  const [validated, setValidated] = useState<boolean>(false);
  const [data, setData] = useState<Parent[]>([]);
  const [text, setText] = useState("");
  const [content, setContent] = useState("");
  const [link, setLink] = useState("");
  const [image, setImage] = useState<File | null>(null);
  const [innerData, setInnerData] = useState([]);
  const [name, setName] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [isResponse, setIsResponse] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  const { user, userLoggedIn, loading, error, userId } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
      userId: state.Auth._id,
    })
  );
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  // useEffect(() => {
  //   fetch('http://165.22.219.69:5002/get/banner')
  //     .then(response => response.json())
  //     .then(res => setBannerData(res))// resolve this response/ promise
  // }, [])

  const handleSubmit = async (event: any) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  //   ------------------------------------------ setting image in the input--------------------------------
  const handleBannerUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage(e.target.files[0]);
    }
  };

  // const handleMobileBannerUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     setMobileBannerUrl(e.target.files[0]);
  //   }
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await fetch(
        //   "http://165.22.219.69:5002/api/footerpage"
        // );
        const response = await api.fetchData(`/api/department`);

        // const response = await fetch("http://165.22.219.69:5002/api/footerpage");

        // if (!response.status == true) {
        //   // console.log("response--", await response.json())
        //   let errorMsg = await response.json();
        //   setIsResponse(errorMsg.message);
        //   // console.log("response from update user---",response)
        //   throw new Error(`HTTP error! Status: ${response.status}`);
        // }
        const data = await response.data;
        setInnerData(data);
        setLink(data[0]?.link);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData(); // Call the async function to fetch and set data
  }, []);

  const updateBanner = async (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const formData = new FormData();
      formData.append("text", text);
      formData.append("content", content);

      if (image) {
        formData.append("image", image);
      }

      try {
        // const response = await fetch(
        //   // `http://165.22.219.69:5002/api/update/footerpage/${objectId}`,
        //   `http://165.22.219.69:5002/api/update/footerpage/${objectId}/${profileId}/${Key_Key}`,
        //   {
        //     method: "PATCH",
        //     body: formData,
        //     credentials: "include",
        //   }
        // );

        const response = await api.updatePatchData(
          `/api/update/department/${itemId}/${profileId}/${Key_Key}`,
          formData
        );

        if (response.status === 440) {
          alert("Session Expired");
          dispatch(logoutUser());
          window.location.href = ADMIN_LOGIN_BASE_URL;
        }

        if (response.status === 429) {
          // console.log("response---6566656", response)
          setShowModal(true);
        }
        // console.log("response--statue", response)

        if (response.status === 400) {
          setIsError(true);
          let errorMessage = await response.json();
          setIsResponse(errorMessage.message);
        }

        // Assuming you want to parse the JSON response
        if (response.status == 200 || response.status == 201) {
          alert("Updated");
          window.location.reload();
        }
      } catch (error) {
        console.error("Error during updating the departent:", error);
      }
    }
    // setValidated(true);
  };

  const cancle = () => {
    const userConfirmed = window.confirm("Cancled");

    if (userConfirmed) {
      window.location.reload();
    }
  };

  return (
    <>
      <Card>
        <Card.Body>
          {(innerData || [])
            .filter((item: Child) => {
              return item._id === itemId;
            })
            .map((filterItem: Child, index: number) => (
              <Form
                style={{ width: "100%" }}
                onSubmit={updateBanner}
                encType="multipart/form-data"
                key={index}
              >
                <h4>Update Department</h4>
                {isError && (
                  <Alert variant="danger" className="my-2">
                    {isResponse}
                  </Alert>
                )}
                {showModal && <AuthModal />}
                {/* <> */}
                <Form.Group>
                  <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                    <h5>Name of the Department</h5>
                  </Form.Label>
                  <Form.Control
                    className="accordion-item"
                    type="text"
                    placeholder={filterItem?.text}
                    defaultValue={filterItem?.text}
                    onChange={(e) => setText(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                    <h5> About Department</h5>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={filterItem?.content}
                    defaultValue={filterItem?.content}
                    onChange={(e) => setContent(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label className="d-flex pt-1 justify-content-start">
                    <h5>Page Backdrop</h5>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    id="image"
                    name="desktopBannerUrl"
                    accept="image/*"
                    onChange={handleBannerUrl}
                  />
                </Form.Group>

                <Form.Group className="pt-2 pb-2">
                  <Row>
                    <Col lg={4}>
                      {/* Delete button */}
                      <Button type="submit">Update</Button>
                    </Col>

                    <Col lg={4}>
                      <button
                        onClick={() => cancle()}
                        className="btn btn-primary"
                      >
                        Cancle
                      </button>
                    </Col>
                  </Row>
                  {/* <Button type="submit">Update</Button> */}
                </Form.Group>
              </Form>
            ))}
        </Card.Body>
      </Card>
    </>
  );
};
// -------------------------------add org item----------------

const AddDepartmentItems: React.FC<id> = ({ id: id, link, name }) => {
  const [validated, setValidated] = useState<boolean>(false);

  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [introduction, setIntroduction] = useState("");
  const [researchBy, setResearchBy] = useState("");
  const [yearOfResearch, setYearOfResearch] = useState("");
  const [awards, setAwards] = useState("");
  const [content, setContent] = useState("");
  const [activeDepartmentId, setActiveDepartmentId] = useState("");

  const [image, setImage] = useState<File | null>(null);

  const [bgColor, setBgColor] = useState("");
  const [address, setAddress] = useState("");
  const [pin, setPin] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [isResponse, setIsResponse] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  const { user, userLoggedIn, loading, error, userId } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
      userId: state.Auth._id,
    })
  );
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  const handleSubmit = async (event: any) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  const AddDepartmentItems = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const formData = new FormData();
      formData.append("title", title);
      formData.append("introduction", introduction);
      formData.append("content", content);
      formData.append("url", url);
      formData.append("researchBy", researchBy);
      formData.append("yearOfResearch", yearOfResearch);
      formData.append("awards", awards);

      formData.append("pin", pin);
      formData.append("address", address);
      formData.append("bgColor", bgColor);

      if (image) {
        formData.append("image", image);
      }
      try {
        // const response = await fetch("http://165.22.219.69:5002/api/footerpage");
        // let url = "";
        // if (name === "link") {
        //   url = `http://165.22.219.69:5002/api/footerlinkitem`;
        // } else if (name === "address") {
        //   url = `http://165.22.219.69:5002/api/footeraddressitem`;
        // } else if (name === "joinUs") {
        //   url = `http://165.22.219.69:5002/api/footerjoinusitem`;
        // } else if (name === "importantLink") {
        //   url = `http://165.22.219.69:5002/api/footerimportantlinkitem`;
        // }

        // let url = "";
        // if (name === "link") {
        //   url = `http://165.22.219.69:5002/api/footerlinkitem`;
        // } else if (name === "address") {
        //   url = `http://165.22.219.69:5002/api/footeraddressitem`;
        // } else if (name === "joinUs") {
        //   url = `http://165.22.219.69:5002/api/footerjoinusitem`;
        // } else if (name === "importantLink") {
        //   url = `http://165.22.219.69:5002/api/footerimportantlinkitem`;
        // }

        let url = "";
        if (name === "About Department") {
          url = `/api/aboutdepartment`;
        } else if (name === "Faculty & Staff") {
          url = `/api/facultyandstaff`;
        } else if (name === "Research & Publications") {
          url = `/api/researchandpublications`;
        } else if (name === "Academics") {
          url = `/api/academics`;
        } else if (name === "In Patient Services") {
          url = `/api/inpatientservice`;
        } else if (name === "Out Patient Services") {
          url = `/api/outpatientservice`;
        } else if (name === "Price List") {
          url = `/api/pricelist`;
        } else if (name === "Links") {
          url = `/api/links`;
        } else if (name === "Gallery") {
          url = `/api/gallery`;
        } else if (name === "Mission & Vision") {
          url = `/api/misionandvision`;
        }

        // const response = await fetch(`${url}/${id}/${profileId}/${Key_Key}`, {
        //   method: "POST",
        //   body: formData,
        //   credentials: "include",
        // });
        const response = await api.createData(
          `${url}/${id}/${profileId}/${Key_Key}`,
          formData
        );

        if (response.status === 440) {
          alert("Session Expired");
          dispatch(logoutUser());
          window.location.href = ADMIN_LOGIN_BASE_URL;
        }

        if (response.status === 429) {
          // console.log("response---6566656", response)
          setShowModal(true);
        }
        // console.log("response--statue", response)

        if (response.status === 400) {
          setIsError(true);
          let errorMessage = await response.json();
          setIsResponse(errorMessage.message);
        }
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Assuming you want to parse the JSON response
        if (response.status == 200 || response.status == 201) {
          alert("Deleted");
          window.location.reload();
        }
      } catch (error) {
        console.error("Error during edit the banner:", error);
      }
    }
    setValidated(true);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage(e.target.files[0]);
    }
  };

  useEffect(() => {
    const storedItemId = localStorage.getItem("parentId");
    setActiveDepartmentId(storedItemId ?? "");
    console.log("activeDepartmentId", activeDepartmentId);
  }, [activeDepartmentId]);

  return (
    <>
      <Card>
        <Card.Body>
          <h4>
            <span style={{ fontSize: "20px", color: "red" }}>
              {name ? name : "Select from above"}
            </span>{" "}
            to add in Department
          </h4>
          {isError && (
            <Alert variant="danger" className="my-2">
              {isResponse}
            </Alert>
          )}
          {showModal && <AuthModal />}
          {name && (
            <Form
              style={{ width: "100%" }}
              onSubmit={AddDepartmentItems}
              encType="multipart/form-data"
            >
              {/* <> */}

              {name == "About Department" || name == "Academics" ? (
                <Form.Group>
                  <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                    <h5>
                      {name == "About Department"
                        ? "Name of the Department "
                        : name == "Academics"
                        ? "Information"
                        : name == "Mission & Vision"
                        ? "Mission"
                        : ""}{" "}
                      <span style={{ color: "red" }}> *</span>
                    </h5>
                  </Form.Label>
                  <Form.Control
                    className="accordion-item"
                    type="text"
                    placeholder={
                      name == "About Department"
                        ? "Name of the Department "
                        : name == "Academics"
                        ? "Information"
                        : name == "Mission & Vision"
                        ? "Mission"
                        : ""
                    }
                    required
                    defaultValue=""
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Group>
              ) : (
                ""
              )}

              {name == "About Department" ? (
                <Form.Group>
                  <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                    <h5>
                      Introduction <span style={{ color: "red" }}> *</span>
                    </h5>
                  </Form.Label>
                  <Form.Control
                    className="accordion-item"
                    type="text"
                    placeholder="Introduction"
                    required
                    defaultValue=""
                    onChange={(e) => setIntroduction(e.target.value)}
                  />
                </Form.Group>
              ) : (
                ""
              )}

              {name == "Research & Publications" ? (
                <>
                  <Form.Group>
                    <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                      <h5>
                        Research Belongs to{" "}
                        <span style={{ color: "red" }}> *</span>
                      </h5>
                    </Form.Label>
                    <Form.Control
                      className="accordion-item"
                      type="text"
                      placeholder="Research Belongs to"
                      required
                      defaultValue=""
                      onChange={(e) => setResearchBy(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                      <h5>
                        About Research and Publications{" "}
                        <span style={{ color: "red" }}> *</span>
                      </h5>
                    </Form.Label>
                    <Form.Control
                      className="accordion-item"
                      type="text"
                      placeholder="About Research and Publications"
                      required
                      defaultValue=""
                      onChange={(e) => setContent(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                      <h5>Awards</h5>
                    </Form.Label>
                    <Form.Control
                      className="accordion-item"
                      type="text"
                      placeholder="Awards"
                      defaultValue=""
                      onChange={(e) => setAwards(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                      <h5>
                        Year <span style={{ color: "red" }}> *</span>
                      </h5>
                    </Form.Label>
                    <Form.Control
                      className="accordion-item"
                      type="text"
                      placeholder="Year of publication"
                      required
                      defaultValue=""
                      onChange={(e) => setYearOfResearch(e.target.value)}
                    />
                  </Form.Group>
                </>
              ) : (
                ""
              )}

              {name == "Mission & Vision" || name == "Academics" ? (
                <>
                  <Form.Group>
                    <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                      <h5>
                        {name == "Mission & Vision"
                          ? "Vision"
                          : name == "Academics"
                          ? "Teaching Programs"
                          : ""}{" "}
                        <span style={{ color: "red" }}> *</span>
                      </h5>
                    </Form.Label>
                    <Form.Control
                      className="accordion-item"
                      type="text"
                      required
                      placeholder="Any Other Information"
                      defaultValue=""
                      onChange={(e) => setContent(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                      <h5>
                        {name == "Mission & Vision"
                          ? " Core Value"
                          : name == "Academics"
                          ? "Addition of new faculty for Teaching"
                          : ""}
                      </h5>
                    </Form.Label>
                    <Form.Control
                      className="accordion-item"
                      type="text"
                      placeholder={
                        name == "Mission & Vision"
                          ? " Core Value"
                          : name == "Academics"
                          ? "Addition of new faculty for Teaching"
                          : ""
                      }
                      defaultValue=""
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </Form.Group>
                </>
              ) : (
                ""
              )}

              {name != "Academics" ? (
                <Form.Group>
                  <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                    <h5>
                      {name == "Mission & Vision"
                        ? "Vision"
                        : "Any Other Information"}{" "}
                      {name == "Mission & Vision" ? (
                        <span style={{ color: "red" }}> *</span>
                      ) : (
                        ""
                      )}
                    </h5>
                  </Form.Label>
                  <Form.Control
                    className="accordion-item"
                    type="text"
                    placeholder="Any Other Information"
                    defaultValue=""
                    onChange={(e) => setContent(e.target.value)}
                  />
                </Form.Group>
              ) : (
                ""
              )}

              <Form.Group>
                <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                  <h5>Url</h5>
                </Form.Label>
                <Form.Control
                  className="accordion-item"
                  type="text"
                  placeholder="Url"
                  defaultValue=""
                  onChange={(e) => setUrl(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="pt-2 pb-2">
                <Button type="submit">Add</Button>
              </Form.Group>
            </Form>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

const UpdateDepartmentItems: React.FC<Props> = ({
  itemId,
  parentId,
  innerdata,
  name,
}) => {
  const [validated, setValidated] = useState<boolean>(false);
  const [serviceSection, setServiceSection] = useState<Parent[]>([]);

  const [showCom, setShowCom] = useState(true);
  const [address, setAddress] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [isResponse, setIsResponse] = useState("");
  const [pin, setPin] = useState("");

  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [introduction, setIntroduction] = useState("");
  const [researchBy, setResearchBy] = useState("");
  const [yearOfResearch, setYearOfResearch] = useState("");
  const [awards, setAwards] = useState("");
  const [content, setContent] = useState("");

  const [image, setImage] = useState<File | null>(null);
  const dispatch = useDispatch<AppDispatch>();

  const { user, userLoggedIn, loading, error, userId } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
      userId: state.Auth._id,
    })
  );
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  const handleSubmit = async (event: any) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const cancle = () => {
    const userConfirmed = window.confirm("Cancled");

    if (userConfirmed) {
      window.location.reload();
    }
  };
  //   ------------------------------------------ setting image in the input--------------------------------
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage(e.target.files[0]);
    }
  };

  const UpdateProtySpotItem = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const formData = new FormData();
      formData.append("title", title);
      formData.append("introduction", introduction);
      formData.append("content", content);
      formData.append("url", url);
      formData.append("researchBy", researchBy);
      formData.append("yearOfResearch", yearOfResearch);
      formData.append("awards", awards);

      formData.append("bgColor", bgColor);

      formData.append("pin", pin);
      formData.append("address", address);
      if (image) {
        formData.append("image", image);
      }

      try {
        // let url = "";
        // if (name === "link") {
        //   url = `http://165.22.219.69:5002/api/footerlinkitem`;
        // } else if (name === "address") {
        //   url = `http://165.22.219.69:5002/api/footeraddressitem`;
        // } else if (name === "joinUs") {
        //   url = `http://165.22.219.69:5002/api/footerjoinusitem`;
        // } else if (name === "importantLink") {
        //   url = `http://165.22.219.69:5002/api/footerimportantlinkitem`;
        // }

        // let url = "";
        // if (name === "link") {
        //   url = `http://165.22.219.69:5002/api/update/footerlinkitem`;
        // } else if (name === "address") {
        //   url = `http://165.22.219.69:5002/api/update/footeraddressitem`;
        // } else if (name === "joinUs") {
        //   url = `http://165.22.219.69:5002/api/update/footerjoinusitem`;
        // } else if (name === "importantLink") {
        //   url = `http://165.22.219.69:5002/api/update/footerimportantlinkitem`;
        // }

        let url = "";
        if (name === "About Department") {
          url = `/api/update/aboutdepartment`;
        } else if (name === "Faculty & Staff") {
          url = `/api/facultyandstaff`;
        } else if (name === "Research & Publications") {
          url = `/api/update/researchandpublications`;
        } else if (name === "Academics") {
          url = `/api/update/academics`;
        } else if (name === "In Patient Services") {
          url = `/api/update/inpatientservice`;
        } else if (name === "Out Patient Services") {
          url = `/api/update/outpatientservice`;
        } else if (name === "Price List") {
          url = `/api/update/pricelist`;
        } else if (name === "Links") {
          url = `/apiupdate/links`;
        } else if (name === "Gallery") {
          url = `/api/update/gallery`;
        } else if (name === "Mission & Vision") {
          url = `/api/update/misionandvision`;
        }
        // const response = await fetch(
        //   `${url}/${parentId}/itemid/${itemId}/${profileId}/${Key_Key}`,
        //   {
        //     method: "PATCH",
        //     body: formData,
        //     credentials: "include",
        //   }
        // );

        // const response = await api.createData(`${url}/${id}/${profileId}/${Key_Key}`, formData);

        const response = await api.updatePatchData(
          `${url}/${parentId}/itemid/${itemId}/${profileId}/${Key_Key}`,
          formData
        );

        if (response.status === 440) {
          alert("Session Expired");
          dispatch(logoutUser());
          window.location.href = ADMIN_LOGIN_BASE_URL;
        }

        if (response.status === 429) {
          // console.log("response---6566656", response)
          setShowModal(true);
        }
        // console.log("response--statue", response)

        if (response.status === 400) {
          setIsError(true);
          let errorMessage = await response.json();
          setIsResponse(errorMessage.message);
        }

        // Assuming you want to parse the JSON response
        if (response.status == 200 || response.status == 201) {
          alert("updated");
          window.location.reload();
        }
      } catch (error) {
        console.error("Error during edit the banner:", error);
      }
    }
    setValidated(true);
  };

  useEffect(() => {
    // This code will run every time itemId changes
    // console.log('itemId has changed:', itemId);
    // You can add any additional logic or updates you want here
  }, [itemId]);

  return (
    <>
      {isError && (
        <Alert variant="danger" className="my-2">
          {isResponse}
        </Alert>
      )}
      {showModal && <AuthModal />}
      <Card>
        <Card.Body>
          {(innerdata || [])
            .filter((item) => {
              return item._id === itemId;
            })
            .map((filterItem, index) => (
              <Form
                style={{ width: "100%" }}
                onSubmit={UpdateProtySpotItem}
                encType="multipart/form-data"
              >
                <h4>Update Details</h4>
                {/* <> */}

                {name == "About Department" ? (
                  <>
                    <Form.Group>
                      <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                        <h5>Name of the Department</h5>
                      </Form.Label>
                      <Form.Control
                        className="accordion-item"
                        type="text"
                        placeholder={filterItem?.title}
                        defaultValue={filterItem?.title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                        <h5>Introduction</h5>
                      </Form.Label>
                      <Form.Control
                        className="accordion-item"
                        type="text"
                        placeholder={filterItem?.introduction}
                        defaultValue={filterItem?.introduction}
                        onChange={(e) => setIntroduction(e.target.value)}
                      />
                    </Form.Group>
                  </>
                ) : (
                  ""
                )}

                {name == "Research & Publications" ? (
                  <>
                    <Form.Group>
                      <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                        <h5>Research Belongs to</h5>
                      </Form.Label>
                      <Form.Control
                        className="accordion-item"
                        type="text"
                        placeholder={filterItem?.researchBy}
                        defaultValue={filterItem?.researchBy}
                        onChange={(e) => setResearchBy(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                        <h5>About Research and Publications</h5>
                      </Form.Label>
                      <Form.Control
                        className="accordion-item"
                        type="text"
                        placeholder={filterItem?.content}
                        defaultValue={filterItem?.content}
                        onChange={(e) => setContent(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                        <h5>Awards</h5>
                      </Form.Label>
                      <Form.Control
                        className="accordion-item"
                        type="text"
                        placeholder={filterItem?.awards}
                        defaultValue={filterItem?.awards}
                        onChange={(e) => setAwards(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                        <h5>Year</h5>
                      </Form.Label>
                      <Form.Control
                        className="accordion-item"
                        type="text"
                        placeholder={filterItem?.yearOfResearch}
                        defaultValue={filterItem?.yearOfResearch}
                        onChange={(e) => setYearOfResearch(e.target.value)}
                      />
                    </Form.Group>
                  </>
                ) : (
                  ""
                )}

                <Form.Group>
                  <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                    <h5>Any Other Information</h5>
                  </Form.Label>
                  <Form.Control
                    className="accordion-item"
                    type="text"
                    placeholder={filterItem?.content}
                    defaultValue={filterItem?.content}
                    onChange={(e) => setContent(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                    <h5>Url</h5>
                  </Form.Label>
                  <Form.Control
                    className="accordion-item"
                    type="text"
                    placeholder={filterItem?.url}
                    defaultValue={filterItem?.url}
                    onChange={(e) => setUrl(e.target.value)}
                  />
                </Form.Group>

                <Row>
                  <Col lg={3}>
                    <Form.Group className="pt-2 pb-2">
                      <Button type="submit">Update</Button>
                    </Form.Group>
                  </Col>
                  <Col lg={3}>
                    <Form.Group className="pt-2 pb-2">
                      <Button
                        className="btn btn-danger"
                        type="button"
                        onClick={() => cancle()}
                      >
                        Cancle
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            ))}
        </Card.Body>
      </Card>
    </>
  );
};
// _________________________________________________________

// const DeleteOriStruItem = ({id}) => {
const DeleteDepartmentItems: React.FC<parentId> = ({ id, link, name }) => {
  const [validated, setValidated] = useState<boolean>(false);
  const [innerdata, setInnerData] = useState<Child[]>([]);
  const [isEditItem, setIsEditItem] = useState<string>("");
  const dispatch = useDispatch<AppDispatch>();
  const { user, userLoggedIn, loading, error, userId } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
      userId: state.Auth._id,
    })
  );
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  useEffect(() => {
    const fetchData = async () => {
      // const response = await fetch("http://165.22.219.69:5002/api/footerpage");
      // let url = "";
      // if (name === "link") {
      //   url = `http://165.22.219.69:5002/api/footerlinkitem`;
      // } else if (name === "address") {
      //   url = `http://165.22.219.69:5002/api/footeraddressitem`;
      // } else if (name === "joinUs") {
      //   url = `http://165.22.219.69:5002/api/footerjoinusitem`;
      // } else if (name === "importantLink") {
      //   url = `http://165.22.219.69:5002/api/footerimportantlinkitem`;
      // }
      // let url = "";
      // if (name === "link") {
      //   url = `http://165.22.219.69:5002/api/footerlinkitem`;
      // } else if (name === "address") {
      //   url = `http://165.22.219.69:5002/api/footeraddressitem`;
      // } else if (name === "joinUs") {
      //   url = `http://165.22.219.69:5002/api/footerjoinusitem`;
      // } else if (name === "importantLink") {
      //   url = `http://165.22.219.69:5002/api/footerimportantlinkitem`;
      // }
      let url = "";
      if (name === "About Department") {
        url = `/api/aboutdepartment`;
      } else if (name === "Faculty & Staff") {
        url = `/api/facultyandstaff`;
      } else if (name === "Research & Publications") {
        url = `/api/researchandpublications`;
      } else if (name === "Academics") {
        url = `/api/academics`;
      } else if (name === "In Patient Services") {
        url = `/api/inpatientservice`;
      } else if (name === "Out Patient Services") {
        url = `/api/outpatientservice`;
      } else if (name === "Price List") {
        url = `/api/pricelist`;
      } else if (name === "Links") {
        url = `/api/links`;
      } else if (name === "Gallery") {
        url = `/api/gallery`;
      } else if (name === "Mission & Vision") {
        url = `/api/misionandvision`;
      }

      try {
        const response = await api.fetchData(`${url}/${id}`);

        if (response.status === 440) {
          alert("Session Expired");
          dispatch(logoutUser());
          window.location.href = ADMIN_LOGIN_BASE_URL;
        }
        setInnerData(response.data.filteredData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the async function to fetch and set data
  }, [name]);

  // --delete org str item
  const deleteItem = async (itemId: string) => {
    try {
      // let url = "";
      // if (name === "link") {
      //   url = `http://165.22.219.69:5002/api/delete/footerlinkitem`;
      // } else if (name === "address") {
      //   url = `http://165.22.219.69:5002/api/delete/footeraddressitem`;
      // } else if (name === "joinUs") {
      //   url = `http://165.22.219.69:5002/api/delete/footerjoinusitem`;
      // } else if (name === "importantLink") {
      //   url = `http://165.22.219.69:5002/api/delete/footerimportantlinkitem`;
      // }

      // let url = "";
      // if (name === "link") {
      //   url = `http://165.22.219.69:5002/api/delete/footerlinkitem`;
      // } else if (name === "address") {
      //   url = `http://165.22.219.69:5002/api/delete/footeraddressitem`;
      // } else if (name === "joinUs") {
      //   url = `http://165.22.219.69:5002/api/delete/footerjoinusitem`;
      // } else if (name === "importantLink") {
      //   url = `http://165.22.219.69:5002/api/delete/footerimportantlinkitem`;
      // }

      let url = "";
      if (name === "About Department") {
        url = `/api/delete/aboutdepartment`;
      } else if (name === "Faculty & Staff") {
        url = `/api/delete/facultyandstaff`;
      } else if (name === "Research & Publications") {
        url = `/api/delete/researchandpublications`;
      } else if (name === "Academics") {
        url = `/api/academics`;
      } else if (name === "In Patient Services") {
        url = `/api/academics`;
      } else if (name === "Out Patient Services") {
        url = `/api/academics`;
      } else if (name === "Price List") {
        url = `/api/academics`;
      } else if (name === "Links") {
        url = `/api/academics`;
      } else if (name === "Gallery") {
        url = `/api/academics`;
      } else if (name === "Mission & Vision") {
        url = `/api/academics`;
      }

      // const response = await fetch(
      //   `${url}/${id}/childid/${itemId}/${profileId}/${Key_Key}`,
      //   {
      //     method: "PATCH",
      //     credentials: "include",
      //   }
      // );

      // const response = await api.updatePatchDataDelete(`/api/delete/department/${itemId}/${profileId}/${Key_Key}`);
      const response = await api.updatePatchDataDelete(
        `${url}/${id}/itemid/${itemId}/${profileId}/${Key_Key}`,
        ""
      );

      if (response.status === 440) {
        alert("Session Expired");
        dispatch(logoutUser());
        window.location.href = ADMIN_LOGIN_BASE_URL;
      }
      if (response.status == 200 || response.status == 201) {
        alert("Deleted");
        window.location.reload();
      }
    } catch (error) {
      console.log("Error during edit the banner:", error);
    }
  };

  // const editItem = async (id: string) => {
  //   let newEditItem = innerdata.find((elem) => {
  //     return elem._id === id;
  //   });
  //   setIsEditItem(id);
  // };

  const editItem = async (id: string) => {
    let newEditItem = innerdata.find((elem) => {
      return elem._id === id;
    });
    setIsEditItem(id);
  };

  // useEffect(() => {
  //   fetch(`http://165.22.219.69:5002/api/statelevelachievementitem/${id}`)
  //     .then((response) => response.json())
  //     .then((res) => setInnerData(res.filteredData));
  // }, []);

  return (
    // <>
    //   <Row>
    //     {isEditItem ? (

    //       <Col lg={10}>
    //         <UpdateDepartmentItems itemId={isEditItem} parentId={id} innerdata={innerdata} link={innerdata} name={name} />
    //       </Col>
    //     ) : (
    //       <>

    //         <Col lg={10}>
    //           <Card>
    //             <Card.Body>
    //               <h4>Update or delete <span style={{ fontSize: '20px', color: 'red' }} >{name ? name : 'Select'}</span></h4>

    //               <Table striped bordered hover>
    //                 <thead>
    //                   <tr>
    //                     <th className="w-5px">#</th>
    //                     <th className="w-60">Notice Title</th>
    //                     <th>Actions</th> {/* New column for actions */}
    //                   </tr>
    //                 </thead>
    //                 {(innerdata || []).map((item, i) => (
    //                   <>
    //                     <tbody>
    //                       <tr key={item._id}>
    //                         <td>{i + 1}</td> {/* You can use i+1 as the index */}
    //                         <td>{item?.title}</td>
    //                         <td>
    //                           {/* Delete button */}
    //                           <Row>
    //                             <Col lg={4}>
    //                               <button
    //                                 onClick={() => deleteItem(item._id)}
    //                                 className="btn btn-danger"
    //                               >
    //                                 Delete
    //                               </button>
    //                             </Col>

    //                             <Col lg={4}>
    //                               <button
    //                                 onClick={() => editItem(item._id)}
    //                                 className="btn btn-primary"
    //                               >
    //                                 Update
    //                               </button>
    //                             </Col>

    //                           </Row>

    //                         </td>
    //                       </tr>
    //                     </tbody>
    //                   </>
    //                 ))}
    //               </Table>
    //             </Card.Body>
    //           </Card>
    //         </Col>

    //       </>
    //     )}
    //   </Row>

    // </>
    <div>
      <Row>
        <Col lg={6}>
          <Card>
            <Card.Body>
              <h4>
                Update or delete{" "}
                <span style={{ fontSize: "20px", color: "red" }}>
                  {name ? name : "Select"}
                </span>
              </h4>

              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th className="w-5px">#</th>
                    <th className="w-60">Notice Title</th>
                    <th>Actions</th> {/* New column for actions */}
                  </tr>
                </thead>
                {(innerdata || []).map((item, i) => (
                  <>
                    <tbody>
                      <tr key={item._id}>
                        <td>{i + 1}</td> {/* You can use i+1 as the index */}
                        <td>{item?.title ? item?.title : item?.researchBy}</td>
                        <td>
                          {/* Delete button */}
                          <Row>
                            <Col lg={4}>
                              <button
                                onClick={() => deleteItem(item._id)}
                                className="btn btn-danger"
                              >
                                Delete
                              </button>
                            </Col>

                            <Col lg={4}>
                              <button
                                onClick={() => editItem(item._id)}
                                className="btn btn-primary"
                              >
                                Update
                              </button>
                            </Col>
                          </Row>
                        </td>
                      </tr>
                    </tbody>
                  </>
                ))}
              </Table>
            </Card.Body>
          </Card>
        </Col>
        {isEditItem ? (
          <Col lg={6}>
            <UpdateDepartmentItems
              itemId={isEditItem}
              parentId={id}
              innerdata={innerdata}
              name={name}
            />
          </Col>
        ) : (
          ""
        )}
      </Row>
    </div>
  );
};

// _______________________________________________________________

const Department = () => {
  const [validated, setValidated] = useState<boolean>(false);
  const [data, setData] = useState<Parent[]>([]);
  const [text, setText] = useState("");
  const [content, setContent] = useState("");
  const [link, setLink] = useState("");
  const [image, setImage] = useState<File | null>(null);
  const [innerData, setInnerData] = useState("");
  const [name, setName] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [isResponse, setIsResponse] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  const { user, userLoggedIn, loading, error, userId } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
      userId: state.Auth._id,
    })
  );
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await fetch(
        //   "http://165.22.219.69:5002/api/footerpage"
        // );
        const response = await api.fetchData(`/api/department`);

        // const response = await fetch("http://165.22.219.69:5002/api/footerpage");

        if (!response.status == true) {
          // console.log("response--", await response.json())
          let errorMsg = await response.json();
          setIsResponse(errorMsg.message);
          // console.log("response from update user---",response)
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.data;

        if (data.length > 0) {
          // Assuming you want to set the pageId to the first item's _id
          // setPageId(data[0]._id);
        }

        setData(data);
        setLink(data[0]?.link);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the async function to fetch and set data
  }, []);

  const handleSubmit = async (event: any) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  //   ------------------------------------------ setting image in the input--------------------------------
  const handleBannerUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage(e.target.files[0]);
    }
  };

  /*---------------- handle Form submit ---------------------------------------*/

  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const formData = new FormData();
      formData.append("text", text);
      formData.append("content", content);
      if (image) {
        formData.append("image", image);
      }

      try {
        // const response = await fetch(
        //   `http://165.22.219.69:5002/api/footerpage/${profileId}/${Key_Key}`,
        //   // const response = await fetch(`http://165.22.219.69:5002/api/footerpage`,

        //   {
        //     method: "POST",
        //     body: formData,
        //     credentials: "include",
        //   }
        // );
        const response = await api.createData(
          `/api/department/${profileId}/${Key_Key}`,
          formData
        );

        if (response.status === 440) {
          alert("Session Expired");
          dispatch(logoutUser());
          window.location.href = ADMIN_LOGIN_BASE_URL;
        }
        if (response.status === 429) {
          // console.log("response---6566656", response)
          setShowModal(true);
        }
        // console.log("response--statue", response)

        if (response.status === 400) {
          setIsError(true);
          let errorMessage = await response.json();
          setIsResponse(errorMessage.message);
        }

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Assuming you want to parse the JSON response
        const data = await response.json();
        if (data) {
          alert("Data Added");
          window.location.reload();
        }
      } catch (error) {
        console.error("Error during edit the banner:", error);
      }
    }
    setValidated(true);
  };

  /*----------------  handle update----------------*/

  let objectId: any;

  if (data.length > 0) {
    const { _id } = data[0];
    objectId = _id;
  }

  const handleUpdate = async (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const formData = new FormData();
      formData.append("text", text);
      formData.append("content", content);

      if (image) {
        formData.append("image", image);
      }

      try {
        // const response = await fetch(
        //   // `http://165.22.219.69:5002/api/update/footerpage/${objectId}`,
        //   `http://165.22.219.69:5002/api/update/footerpage/${objectId}/${profileId}/${Key_Key}`,
        //   {
        //     method: "PATCH",
        //     body: formData,
        //     credentials: "include",
        //   }
        // );

        const response = await api.updatePatchData(
          `/api/update/department/${objectId}/${profileId}/${Key_Key}`,
          formData
        );

        if (response.status === 440) {
          alert("Session Expired");
          dispatch(logoutUser());
          window.location.href = ADMIN_LOGIN_BASE_URL;
        }

        if (response.status === 429) {
          // console.log("response---6566656", response)
          setShowModal(true);
        }
        // console.log("response--statue", response)

        if (response.status === 400) {
          setIsError(true);
          let errorMessage = await response.json();
          setIsResponse(errorMessage.message);
        }
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Assuming you want to parse the JSON response
        const data = await response.json();
        // const userConfirmed = window.confirm("updated");

        if (data) {
          alert("Data updated");
          window.location.reload();
        }
      } catch (error) {
        console.error("Error during edit the banner:", error);
      }
    }
    setValidated(true);
  };

  const showItem = (item: any) => {
    // if (item === 'link') setInnerData(data[0]?.link); setName(item);
    if (item === "About Department") {
      if (data[0]?.aboutus !== undefined) {
        setInnerData(data[0]?.aboutus);
        setName(item);
      }
    }

    if (item === "Faculty & Staff") {
      if (data[0]?.facultyAndStaff !== undefined) {
        setInnerData(data[0]?.facultyAndStaff);
        setName(item);
      }
    }

    if (item === "Research & Publications") {
      if (data[0]?.researchAndPublications !== undefined) {
        setInnerData(data[0]?.researchAndPublications);
        setName(item);
      }
    }
    if (item === "Academics") {
      if (data[0]?.academics !== undefined) {
        setInnerData(data[0]?.academics);
        setName(item);
      }
    }
    if (item === "In Patient Services") {
      if (data[0]?.inPatientService !== undefined) {
        setInnerData(data[0]?.inPatientService);
        setName(item);
      }
    }
    if (item === "Out Patient Services") {
      if (data[0]?.outPatientService !== undefined) {
        setInnerData(data[0]?.outPatientService);
        setName(item);
      }
    }
    if (item === "Price List") {
      if (data[0]?.priceList !== undefined) {
        setInnerData(data[0]?.priceList);
        setName(item);
      }
    }
    if (item === "Links") {
      if (data[0]?.MisionAndVision !== undefined) {
        setInnerData(data[0]?.MisionAndVision);
        setName(item);
      }
    }
    if (item === "Gallery") {
      if (data[0]?.links !== undefined) {
        setInnerData(data[0]?.links);
        setName(item);
      }
    }
    if (item === "Mission & Vision") {
      if (data[0]?.gallery !== undefined) {
        setInnerData(data[0]?.gallery);
        setName(item);
      }
    }
  };

  return (
    <>
      <div>
        <Card>
          <Card.Body>
            <Row>
              {/* {data.length === 0 ? ( */}
              <Col lg={5}>
                <Form
                  style={{ width: "100%" }}
                  onSubmit={handleFormSubmit}
                  encType="multipart/form-data"
                >
                  <h4>Add Department</h4>
                  {isError && (
                    <Alert variant="danger" className="my-2">
                      {isResponse}
                    </Alert>
                  )}
                  {showModal && <AuthModal />}
                  {/* <> */}
                  <Form.Group>
                    <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                      <h5>
                        Name of the Department{" "}
                        <span style={{ color: "red" }}> *</span>
                      </h5>
                    </Form.Label>
                    <Form.Control
                      className="accordion-item"
                      type="text"
                      placeholder="Name of the Department"
                      required
                      defaultValue=""
                      onChange={(e) => setText(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                      <h5>
                        About Department{" "}
                        <span style={{ color: "red" }}> *</span>{" "}
                      </h5>
                    </Form.Label>
                    <Form.Control
                      className="accordion-item"
                      type="text"
                      placeholder="About Department"
                      defaultValue=""
                      onChange={(e) => setContent(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className="d-flex pt-1 justify-content-start">
                      <h5>Page Backdrop</h5>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      id="image"
                      name="bannerUrl"
                      accept="image/*"
                      onChange={handleBannerUrl}
                    />
                  </Form.Group>

                  <Form.Group className="pt-2 pb-2">
                    <Button type="submit">Add</Button>
                  </Form.Group>
                </Form>
              </Col>
              {/* ) : ( */}
              {/* Update Departent */}
              {/* <Col lg={6}>
                  <Form
                    style={{ width: "100%" }}
                    onSubmit={handleUpdate}
                    encType="multipart/form-data"
                  >
                    <h4>Update Footer Page</h4>
                    {isError && (
                      <Alert variant="danger" className="my-2">
                        {isResponse}
                      </Alert>
                    )}
                    {showModal && <AuthModal />}

                    <Form.Group>
                      <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                        <h5>
                          Name of the Department <span style={{ color: "red" }}> *</span>{" "}
                        </h5>
                      </Form.Label>
                      <Form.Control
                        className="accordion-item"
                        type="text"
                        required
                        placeholder="Heading"
                        defaultValue={data[0]?.text}
                        onChange={(e) => setText(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label className="d-flex  pt-2justify-content-start font-weight-bold">
                        <h5>About Department</h5>
                      </Form.Label>
                      <Form.Control
                        className="accordion-item"
                        type="text"
                        placeholder="Content"
                        defaultValue={data[0]?.content}
                        onChange={(e) => setContent(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label className="d-flex pt-1 justify-content-start">
                        <h5>Page Backdrop</h5>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        id="image"
                        name="bannerUrl"
                        accept="image/*"
                        onChange={handleBannerUrl}
                      />
                    </Form.Group>

                    <Form.Group className="pt-2 pb-1">
                      <Button type="submit">Update</Button>
                    </Form.Group>
                  </Form>
                </Col> */}

              {/* )} */}

              {/* =============== practice ---------------- */}

              {/* -------------------------- update data--------------------------------------------- */}
              <Col lg={7}>{data && <DeleteDepartment data={data} />}</Col>
            </Row>

            {/* --------- department child design  ---------- */}

            <div
              style={{ width: "100%", height: "1px", backgroundColor: "red" }}
            ></div>
            {/* ----------- */}

            <Row>
              <Col lg={12}>
                <h3>Choose the following item to work on it</h3>
                <div className="d-flex  flex-wrap w-100">
                  {(footerItems || []).map((item, index) => (
                    <div
                      style={{ fontSize: "20px", padding: "10px 20px" }}
                      key={index}
                    >
                      <Button onClick={() => showItem(item.name)}>
                        <h4>{item.name}</h4>
                      </Button>
                    </div>
                  ))}
                </div>
              </Col>

              <Col lg={12}>
                {data && (
                  <AddDepartmentItems
                    id={objectId}
                    link={innerData}
                    name={name}
                  />
                )}
              </Col>
            </Row>
            {/* ----------- */}
            <Row>
              <Col lg={12}>
                {objectId && data && (
                  <DeleteDepartmentItems
                    id={objectId}
                    link={innerData}
                    name={name}
                  />
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default Department;
